import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: 'AIzaSyC4ajY0yvjlis9AolgVjOseSLoXPRJDf2I',
  authDomain: 'ecowhips.firebaseapp.com',
  databaseURL: 'https://ecowhips.firebaseio.com',
  projectId: 'ecowhips',
  storageBucket: 'ecowhips.appspot.com',
  messagingSenderId: '621566771224'
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const storage = firebase.storage()

// date issue fix according to firebase
/*
const settings = {
    timestampsInSnapshots: true
}
db.settings(settings)
*/

// firebase collections
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')

export {
  db,
  auth,
  currentUser,
  usersCollection,
  postsCollection,
  commentsCollection,
  likesCollection,
  storage
}
